var React = require('react');
var cx = require('classnames');

class Item extends React.Component {

  checkbox () {
    var classes = ['fa', 'pull-right'];
    if (this.props.item.selected) {
      classes = cx(classes, 'fa-check-square-o');
    } else {
      classes = cx(classes, 'fa-square-o', 'color-secondary');
    }
    return <i className={classes}></i>;
  }

  render () {
    var classes = ['grouped-item', 'border-color', this.props.className];
    if (this.props.item.selected) classes.push('active');

    return (
      <div className={cx(classes)}
           onClick={this.props.toggle.bind(null, this.props.item)}>
        <span>{this.props.item.name}</span>
        <span style={{display: 'none'}}>{this.props.item.id}</span>
        {this.checkbox()}
      </div>
    )
  }
}

module.exports = Item;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/items_selector/item.jsx